import { createFileRoute } from '@tanstack/react-router'
import { PersonScreen } from '@web/app/features/person'
import { Users } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/documents/persons')({
  component: PersonScreen,
  staticData: {
    metaRoute: {
      title: 'Personas',
      order: 3,
      icon: Users,
    },
  },
})
